import { StrictMode } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';

import { ThemeProvider } from '@/components/shadcn/ui/ThemeProvider.tsx';
import { HistoryTrackers } from '@/components/trackers';
import { DogeProvider } from '@/networks/btc-like/doge';
import { LitecoinProvider } from '@/networks/btc-like/ltc';
import { SwapContextProvider } from '@/pages/Swap/context';

import { BtcProvider } from '../networks/btc-like/btc';
import { CoinwebProvider } from '../networks/coinweb';
import { WagmiWrapper } from '../networks/evm';
import { TronProvider } from '../networks/tron';

import Globals from './Globals';
import { Router } from './Router';
import { queryClient } from './queryClient';

export const App = () => {
  return (
    <StrictMode>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <DogeProvider>
          <LitecoinProvider>
            <TronProvider>
              <BtcProvider>
                <CoinwebProvider>
                  <WagmiWrapper>
                    <QueryClientProvider client={queryClient}>
                      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
                        <SwapContextProvider>
                          <Globals />
                          <Router />
                        </SwapContextProvider>
                        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" position="left" />
                        <HistoryTrackers />
                      </ThemeProvider>
                    </QueryClientProvider>
                  </WagmiWrapper>
                </CoinwebProvider>
              </BtcProvider>
            </TronProvider>
          </LitecoinProvider>
        </DogeProvider>
      </BrowserRouter>
    </StrictMode>
  );
};
